module.exports = __webpack_public_path__ + "static/media/image-18.94436abb.jpg";